import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "panel" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_banner = _resolveComponent("info-banner")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_sidebar_button = _resolveComponent("app-sidebar-button")!
  const _component_app_sidebar_expedition = _resolveComponent("app-sidebar-expedition")!
  const _component_app_sidebar_order = _resolveComponent("app-sidebar-order")!
  const _component_app_sidebar_security = _resolveComponent("app-sidebar-security")!
  const _component_app_sidebar_logistics = _resolveComponent("app-sidebar-logistics")!
  const _component_app_sidebar_fuel = _resolveComponent("app-sidebar-fuel")!
  const _component_app_sidebar_clients = _resolveComponent("app-sidebar-clients")!
  const _component_app_sidebar_mailing = _resolveComponent("app-sidebar-mailing")!
  const _component_app_sidebar_support = _resolveComponent("app-sidebar-support")!
  const _component_app_sidebar_timer = _resolveComponent("app-sidebar-timer")!
  const _component_app_sidebar = _resolveComponent("app-sidebar")!
  const _component_default_transition = _resolveComponent("default-transition")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_about_program = _resolveComponent("about-program")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.wrapper)
  }, [
    _createVNode(_component_info_banner, {
      visible: $data.isBannerVisible,
      "is-expedition-active": $options.isExpeditionActive,
      "is-fuel-active": $options.isFuelActive,
      "is-logistics-active": $options.isLogisticsActive,
      "is-mrz-active": $options.isClientsActive,
      "is-orders-active": $options.isOrdersActive,
      "is-security-active": $options.isSecurityActive,
      "onToggle:banner": $options.toggleBannerVisible
    }, null, 8, ["visible", "is-expedition-active", "is-fuel-active", "is-logistics-active", "is-mrz-active", "is-orders-active", "is-security-active", "onToggle:banner"]),
    _createElementVNode("div", {
      class: _normalizeClass($options.containerStyles)
    }, [
      _createVNode(_component_app_header, {
        "is-expedition-active": $options.isExpeditionActive,
        "is-fuel-active": $options.isFuelActive,
        "is-logistics-active": $options.isLogisticsActive,
        "is-mrz-active": $options.isClientsActive,
        "is-orders-active": $options.isOrdersActive,
        "is-security-active": $options.isSecurityActive,
        "is-integration-monitor": $options.isIntegrationMonitor,
        "is-tasks-active": $options.isTasksActive,
        onAboutModalOpen: _cache[0] || (_cache[0] = ($event: any) => ($data.isAboutModal = true))
      }, null, 8, ["is-expedition-active", "is-fuel-active", "is-logistics-active", "is-mrz-active", "is-orders-active", "is-security-active", "is-integration-monitor", "is-tasks-active"]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.main)
      }, [
        _createVNode(_component_app_sidebar, {
          class: _normalizeClass($options.sibebarClasses)
        }, {
          default: _withCtx(() => [
            ($options.isTasksActive)
              ? (_openBlock(), _createBlock(_component_app_sidebar_button, {
                  key: 0,
                  "included-routes": ['task-tracker'],
                  "is-wide": $data.isWide,
                  to: { name: 'tasks' },
                  caption: "Задачи",
                  icon: "dashboard"
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true),
            ($options.isExpeditionActive)
              ? (_openBlock(), _createBlock(_component_app_sidebar_expedition, {
                  key: 1,
                  "is-wide": $data.isWide,
                  "blink-elements": $data.blinkElements,
                  "onHide:blink": $options.onClickHideBlink
                }, null, 8, ["is-wide", "blink-elements", "onHide:blink"]))
              : _createCommentVNode("", true),
            ($options.isOrdersActive)
              ? (_openBlock(), _createBlock(_component_app_sidebar_order, {
                  key: 2,
                  "is-wide": $data.isWide
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true),
            ($options.isSecurityActive)
              ? (_openBlock(), _createBlock(_component_app_sidebar_security, {
                  key: 3,
                  "is-wide": $data.isWide
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true),
            ($options.isLogisticsActive)
              ? (_openBlock(), _createBlock(_component_app_sidebar_logistics, {
                  key: 4,
                  "is-wide": $data.isWide
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true),
            ($options.isFuelActive)
              ? (_openBlock(), _createBlock(_component_app_sidebar_fuel, {
                  key: 5,
                  "is-wide": $data.isWide
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true),
            ($options.isClientsActive)
              ? (_openBlock(), _createBlock(_component_app_sidebar_clients, {
                  key: 6,
                  "is-wide": $data.isWide
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true),
            ($options.isIntActive)
              ? (_openBlock(), _createBlock(_component_app_sidebar_button, {
                  key: 7,
                  caption: "Мониторинг",
                  icon: "dashboard",
                  to: { name: 'integration-monitor-summary' },
                  "included-routes": [
                'integration-monitor-summary',
              ],
                  "is-wide": $data.isWide
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true),
            ($options.isIntActive)
              ? (_openBlock(), _createBlock(_component_app_sidebar_button, {
                  key: 8,
                  caption: "Мониторинг",
                  icon: "table_view",
                  to: { name: 'integration-monitor-detail' },
                  "included-routes": [
                'integration-monitor-detail',
              ],
                  "is-wide": $data.isWide
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true),
            (_ctx.$can('use', 'UsersMailing'))
              ? (_openBlock(), _createBlock(_component_app_sidebar_mailing, {
                  key: 9,
                  "is-wide": $data.isWide
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true)
          ]),
          bottom: _withCtx(() => [
            (_ctx.$can('useSupport', 'AppLayout'))
              ? (_openBlock(), _createBlock(_component_app_sidebar_support, {
                  key: 0,
                  "is-wide": $data.isWide
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true),
            ($options.showFuelInstruction)
              ? (_openBlock(), _createBlock(_component_app_sidebar_button, {
                  key: 1,
                  href: $options.fuelInstructionLink,
                  "is-wide": $data.isWide,
                  caption: "Инструкция",
                  icon: "files/doc",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  type: "a"
                }, null, 8, ["href", "is-wide"]))
              : _createCommentVNode("", true),
            ($options.isExpeditionActive)
              ? (_openBlock(), _createBlock(_component_app_sidebar_button, {
                  key: 2,
                  "included-routes": ['srm-profile', 'security', 'srm-notifications'],
                  "is-wide": $data.isWide,
                  to: { name: 'srm-profile' },
                  caption: "Настройки",
                  icon: "settings"
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true),
            ($options.isOrdersActive)
              ? (_openBlock(), _createBlock(_component_app_sidebar_button, {
                  key: 3,
                  "included-routes": ['crm-profile', 'crm-notifications'],
                  "is-wide": $data.isWide,
                  to: { name: 'crm-profile' },
                  caption: "Настройки",
                  icon: "settings"
                }, null, 8, ["is-wide"]))
              : _createCommentVNode("", true),
            _createVNode(_component_app_sidebar_timer)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_component_default_transition, null, {
              default: _withCtx(() => [
                ($data.isReady)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                      key: 0,
                      id: "content",
                      class: _normalizeClass(_ctx.$style.content)
                    }, null, 8, ["class"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _hoisted_1,
        ($data.isAboutModal)
          ? (_openBlock(), _createBlock(_component_about_program, {
              key: 0,
              onClose: _cache[1] || (_cache[1] = ($event: any) => ($data.isAboutModal = false))
            }))
          : _createCommentVNode("", true)
      ], 2)
    ], 2)
  ], 2))
}